var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-coupon-table',{attrs:{"title":_vm.$t('global.models.coupon.heading'),"subtitle":_vm.$t('global.models.coupon.subheading'),"create-form-config-name":'default-with-multiple-contacts',"edit-form-config-name":'default'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }